// Newest first. Add a new entry here every time the version in package.json is bumped.
// Small fixes: +0.0.1  |  New features: +0.1
export const RELEASE_NOTES = [
  {
    version: '1.6.0',
    date: 'October 2026',
    changes: [
      { type: 'new', text: 'A "New" tag appears next to the footer version whenever there are upgrade notes you haven\'t read. It clears once you open them, on every device.' },
    ],
  },
  {
    version: '1.5.0',
    date: 'October 2026',
    changes: [
      { type: 'new', text: 'Version number in the footer now opens this list of upgrades.' },
      { type: 'improved', text: 'No more forced password changes. Sign-in codes already protect every login, so people change their password only when they want to.' },
      { type: 'new', text: 'Optional "Require periodic password changes" switch in Setup → Security (off by default).' },
      { type: 'new', text: 'After an admin sets or resets someone\'s password, that person is asked once to choose their own.' },
      { type: 'improved', text: 'Checkbook attachments are now stored safely in the cloud so they survive updates.' },
      { type: 'fixed', text: 'Opening a Checkbook attachment now works.' },
      { type: 'fixed', text: 'LLC document download links no longer return "not found".' },
    ],
  },
  {
    version: '1.4.0',
    date: 'August 2026',
    changes: [
      { type: 'improved', text: 'Weekly database backup email redesigned with a clear summary of date, file name, size and backup type.' },
      { type: 'new', text: 'Show/hide eye on the SMTP password field.' },
      { type: 'new', text: 'Send a test email to any address from SMTP Configuration.' },
      { type: 'improved', text: 'Version number now updates automatically with each release.' },
      { type: 'fixed', text: 'Amounts no longer show as "-$0.00".' },
    ],
  },
  {
    version: '1.3.1',
    date: 'July 2026',
    changes: [
      { type: 'fixed', text: 'Balance Sheet no longer shows phantom liabilities after expense refunds or reversals.' },
      { type: 'fixed', text: 'Quarterly Statements now include selected LLCs with no activity, listed alphabetically.' },
      { type: 'fixed', text: 'Corrected year-end Accounts Payable / Legal entries for GCBS Representative.' },
      { type: 'new', text: 'Sort the Checking drill-down by date, reference, vendor, category or amount.' },
      { type: 'improved', text: 'Safer printing for reports, vendors and LLC pages.' },
    ],
  },
  {
    version: '1.3.0',
    date: 'May 2026',
    changes: [
      { type: 'new', text: 'Two-step sign-in: a 6-digit code is emailed at login, and trusted devices are remembered for 30 days.' },
      { type: 'new', text: 'Quarterly Financial Statements emailed to each partner, with Income Statement and Balance Sheet per LLC and a preview before sending.' },
      { type: 'new', text: '"Issue financial statements" switch per LLC to leave tracking-only entities out of the quarterly emails.' },
      { type: 'improved', text: 'Weekly Task Digest card can be collapsed in Setup → Communications.' },
    ],
  },
  {
    version: '1.2.1',
    date: 'April 2026',
    changes: [
      { type: 'new', text: '"My LLCs" toggle on the dashboard for managers to show only LLCs they own a share of.' },
      { type: 'fixed', text: 'Managers can now print 1099 forms.' },
      { type: 'new', text: 'Page-view tracking for usage reporting.' },
    ],
  },
  {
    version: '1.2.0',
    date: 'March 2026',
    changes: [
      { type: 'new', text: '1099 and 1096 form generation for vendors.' },
      { type: 'new', text: 'Appraised value field on each LLC.' },
      { type: 'new', text: 'Blue star to mark an LLC\'s distributions and admin as current.' },
      { type: 'improved', text: 'Report drill-downs show a running balance.' },
    ],
  },
  {
    version: '1.1.0',
    date: 'February 2026',
    changes: [
      { type: 'new', text: 'Option to hide ownership percentages from partners on an LLC.' },
      { type: 'new', text: 'Gold star to mark an LLC\'s information as current and verified.' },
      { type: 'new', text: 'Dashboard header with date, time, weather and market ticker.' },
      { type: 'fixed', text: 'Current-year earnings now roll prior years into Retained Earnings.' },
      { type: 'fixed', text: 'Partners can see the Partners tab on LLCs they own.' },
    ],
  },
  {
    version: '1.0.0',
    date: 'February 2026',
    changes: [
      { type: 'new', text: 'First release: LLC and partner setup with ownership percentages.' },
      { type: 'new', text: 'Checkbook ledger, journal entries and account categories.' },
      { type: 'new', text: 'Balance Sheet, Income Statement and General Ledger reports.' },
      { type: 'new', text: 'Documents, communication log and tasks for each LLC.' },
      { type: 'new', text: 'User roles (Superadmin, Manager, Professional, Partner), login history, session timeout and backups.' },
    ],
  },
];
